import Vue from 'vue'
import settings from '@/settings.coffee'

export default {
    "gql_mutation_review_set_use_as_example": (uid, value)->
        return """
        mutation{
            review_set_use_as_logos_example(uid:"#{uid}", new_value:#{value}){
                ok
            }
        }
        """
    "gql_mutation_state_call_action": (uid, action_slug)->
        return """
        mutation{
          state_call_action(state:{uid:"#{uid}",action_slug:"#{action_slug}"}) {
            uid
          }
        }
        """
    "gql_mutation_logosanswer_reset_scores": (uid)->
        return """
        mutation{
            logosanswer_reset_human_scores(
                uid:"#{uid}"
            ) {
                ok, msg
            }
        }
        """
    "gql_mutation_logosanswer_set_human_scores": (uid, 
            score_human_global_note, 
            score_human_style_respect, 
            score_human_answers_diversity, 
            score_human_review_context, 
            score_human_marketing, 
            score_human_no_hallucinations,
            score_human_comments,
            )->
        comments = btoa(encodeURIComponent(score_human_comments))
        return """
        mutation{
            logosanswer_set_human_scores(
                uid:"#{uid}",
                score_human_global_note:#{score_human_global_note}, 
                score_human_style_respect:#{score_human_style_respect}, 
                score_human_answers_diversity:#{score_human_answers_diversity}, 
                score_human_review_context:#{score_human_review_context}, 
                score_human_marketing:#{score_human_marketing}, 
                score_human_no_hallucinations:#{score_human_no_hallucinations},
                score_human_comments:"#{comments}",
            ) {
                ok, msg
            }
        }
        """
    "gql_mutation_review_update_positive": (uid, positive)->
        return """
        mutation{
          review_upsert(input:{uid:"#{uid}", positive:#{positive}}) {
            uid
            clientMutationId
          }
        }
        """
    "gql_mutation_avatar_upload": (uid, imgdata, imgFileName)->
        return """
        mutation{
          consultant_update_avatar(id:"#{uid}", img:"#{imgdata}", filename:"#{imgFileName}") {
            ok
          }
        }
        """
    "notify_without_email": (review_state_uid, asap, to_gathering)->
        return """
        mutation{email_fake_send(review_state_uid: "#{review_state_uid}", asap:#{asap}, to_gathering:#{to_gathering}){
            ok
        }}
        """
    "notification_delete_read": (uid)->
        return """
        mutation{notification_delete_read{
            ok
        }}
        """
    "notification_mark_done": (uid)->
        return """
        mutation{notification_upsert(input:{uid:"#{uid}", done:true}){
            uid
        }}
        """
    "notification_delete": (uid)->
        return """
        mutation{notification_delete(id:"#{uid}"){
            ok
        }}
        """
    "notification_toggle_done": (uid)->
        return """
        mutation{notification_toggle_read(uid:"#{uid}"){
            ok
        }}
        """        
    "message_mark_read": (uid)->
        return """
        mutation{alert_upsert(input:{uid:"#{uid}", read:true}){
            uid
        }}
        """
    "review_generate_logos_answer": (uid, assistant_uid, additional_informations)->
        return """
        mutation{review_generate_logos_answer(review_uid:"#{uid}", assistant_uid: "#{assistant_uid}", additional_informations: "#{additional_informations}"){
            ok
            msg
        }}
        """
    "batch_reviews_generate_logos_answer": (uids)->
        return """
        mutation{batch_reviews_generate_logos_answer(reviews_uid: #{JSON.stringify(uids)} ){
            ok
            msg
        }}
        """
    "message_delete": (uid)->
        return """
        mutation{alert_delete(id:"#{uid}"){
            ok
        }}
        """
    "establishment_update_logo": (uid, imgdata, imgFileName)->
        return """
        mutation{
          establishment_update_logo(id:"#{uid}", img:"#{imgdata}", filename:"#{imgFileName}") {
            ok
          }
        }        
        """
    "establishment_update_main_picture": (uid, imgdata, imgFileName)->
        return """
        mutation{
          establishment_update_main_picture(id:"#{uid}", img:"#{imgdata}", filename:"#{imgFileName}") {
            ok
          }
        }
        """
    "establishment_update_picture": (uid, establishment_uid, imgdata, imgFileName)->
        return """
        mutation{
          establishment_update_picture(id:"#{uid}", establishment_id:"#{establishment_uid}" img:"#{imgdata}", filename:"#{imgFileName}") {
            ok
          }
        }
        """
    "update_state_data": (uid, serialized) ->
        return """
        mutation {
            state_upsert(input:{uid:"#{uid}", data_b64:"#{serialized}"}) {
                uid
            }
        }
        """
    "delete_review_state": (uid) ->
        return """
        mutation {
            state_delete(id:"#{uid}") {
                ok
            }
        }
        """
    "review_state_back": (uid) ->
        return """
        mutation{review_state_back(id:"#{uid}"){ok}}
        """
    "save_next_report_text": (establishement_uid, text)->
        return """
        mutation{establishment_save_next_report_text(id:"#{establishement_uid}", text:"#{text}"){ok}}
        """
    "update_review_lang": (review_uid, lang_uid)->
        return """
        mutation{review_upsert(input:{
            uid:"#{review_uid}",
            native_lang:"#{lang_uid}"}
        ){uid}}
        """
    "update_review_text_fr": (review_uid, text_fr, title_fr)->
        text = text_fr.replace(/"/g,"'").replace(/\n/g,"\\n")
        title = title_fr.replace(/"/g,"'").replace(/\n/g,"\\n")        
        return """
        mutation{review_upsert(input:{
            uid:"#{review_uid}",
            text_fr:"#{text}",
            title_fr:"#{title}"}
        ){uid}}
        """
    "update_review_answerer": (review_uid, answerer_uid)->
        return """
        mutation{review_upsert(input:{
            uid:"#{review_uid}",
            answerer:"#{answerer_uid}"}
        ){uid}}
        """
    "create_or_update_assistant_with_step": (uid, name, step_set, specialist_platform_id, specialist_sentiment, is_active) ->
        step_set_filtered = []
        for step in step_set
            if step.example_choice_strategy is null
                step.example_choice_strategy = "null"
            if step.example_selection_strategy is null
                step.example_selection_strategy = "null"
            if step.example_fill_strategy is null
                step.example_fill_strategy = "null"
            step.encoded_prompt = btoa(unescape(encodeURIComponent(step.prompt)))
            if step.example_fixed_n is null or step.example_fill_strategy == "null"
                step.example_fixed_n = 0
            step.example_fixed_n = parseInt(step.example_fixed_n, 10)
                # step_llm_name = graphene.String(required=False)
        # # step_max_tokens_input = graphene.Int(required=False)
        # step_temperature = graphene.Float(required=False)
        # step_max_output_tokens = graphene.Int(required=False)
        # step_max_input_tokens = graphene.Int(required=False)
        # # step_top_p = graphene.Float(required=False)
        # step_model_type = graphene.String(required=False)
        
        # step_search_examples = graphene.Boolean(required=True)
        # step_example_choice_strategy = graphene.String(required=False)
        # step_example_selection_strategy = graphene.String(required=False)
        # step_example_fill_strategy = graphene.String(required=False)
        # step_prompt_base64 = graphene.String(required=False)

            keys = ['llm_name', 'temperature', 'max_output_tokens', 'max_input_tokens', 'search_examples', 'example_fixed_n', 'example_choice_strategy', 'example_selection_strategy', 'example_fill_strategy', 'encoded_prompt']
            step_set_filtered.push(Object.fromEntries Object.entries(step).filter ([key]) -> key in keys)
        if specialist_platform_id == "undefined"
            specialist_platform_id = "null"


        graphql_step_set = '['

        for step in step_set_filtered
            graphqlItem = '{'
            for key, value of step
                graphqlItem += "#{key}: #{JSON.stringify(value)}, "
                # graphqlItem = graphqlItem.replace(/, $/, '') # Remove trailing comma and space
            graphqlItem += '}, '
            graphql_step_set += graphqlItem

        # graphql_step_set = graphql_step_set.replace(/, $/, '') # Remove trailing comma and space
        graphql_step_set += ']'
        return """
          mutation {assistant_step_mutation(
            uid: "#{uid}",
            name: "#{name}",
            step_set: #{graphql_step_set},
            specialist_platform_id: "#{specialist_platform_id}",
            specialist_sentiment: "#{specialist_sentiment}",
            is_active: #{is_active},


              )
            {
              assistant {
                uid
                name
              }
              step {
                uid
                llm_name
              }
            }
            }
        """

    "update_assistant_specialisations": (assistant_name, assistant_uid, sentiment, plateform)->
        return """
        mutation{assistant_upsert(input:{
            name: "#{assistant_name}",
            uid:"#{assistant_uid}",
            specialist_sentiment:"#{sentiment}",
            spectialist_plateform:"#{plateform}",
            }
        ){uid}}
        """
    "update_assistant_active_status": (assistant_name, assistant_uid, is_active)->
        return """
        mutation{assistant_step_mutation(input:{
            name: "#{assistant_name}",
            uid:"#{assistant_uid}",
            is_active:#{is_active},
            }
        ){uid}}
        """
    "affect_assistant": (assistant_uid, establishment_uids)->
        establishment_uids_str = "[" + (establishment_uids.map((uid) -> "\"#{uid}\"")).join(", ") + "]"
        return """
            mutation {affect_assistant(
                assistant_uid: "#{assistant_uid}",
                establishment_uids: #{establishment_uids_str},
            )
            {
                n_affectation_created
                n_affectation_deleted
            }
            }
            """
    # "vote_for_best_answer": (best_answer_id = null, best_button_pushed = null) ->
    #     best_answer_id_part = if best_answer_id then "best_answer_id: \"#{best_answer_id}\"," else ""
    #     best_button_pushed_part = if best_button_pushed != null then "best_button_pushed: #{best_button_pushed}," else ""
    #     return """
    #     mutation {
    #         vote_for_best_answer(
    #             #{best_answer_id_part}
    #             #{best_button_pushed_part}
    #         ) {
    #             game {
    #                 uid
    #             }
    #         }
    #     }
    #     """
    "update_game": (id, best_answer_id = null, best_button_pushed = null, copy_button_pushed = null, copied_answer_id=null) ->
        best_answer_id_part = if best_answer_id then "best_answer_id: \"#{best_answer_id}\"," else ""
        best_button_pushed_part = if best_button_pushed != null then "best_button_pushed: #{best_button_pushed}," else ""
        copy_button_pushed_part = if copy_button_pushed != null then "copy_button_pushed: #{copy_button_pushed}," else ""
        copied_answer_id_part = if copied_answer_id != null then "copied_answer_id: \"#{copied_answer_id}\"," else ""

        return """
        mutation {
            update_game(
                id: "#{id}",
                #{best_answer_id_part}
                #{best_button_pushed_part}
                #{copy_button_pushed_part}
                #{copied_answer_id_part}
            ) {
                game {
                    uid
                }
            }
        }
        """
    "review_ensure_all_games": (uid) ->
        return """
        mutation {
            review_ensure_all_games(review_uid: "#{uid}"){
                ok
                msg
            }
        }
        """
    "update_answer": (uid, improve_text) ->
        # safe_text = improve_text.replace('"', "'")
        # base64 safety (avoid pb with quotes, double quotes, etc)
        safe_text = btoa(improve_text)
        return """
        mutation {
            improve_answer(answer_uid: "#{uid}", text: "#{safe_text}"){
                ok
                msg
            }
        }
        """
    "delete_link": (uid)->
        return """
        mutation{delete_link(id: "#{uid}"){
            ok
        }}
        """
    "update_link": (uid, label, href)->
        return """
        mutation{
            update_link(uid: "#{uid}", label: "#{label}", href: "#{href}"){
                link {
                    uid
                    label
                    href
                    slug
                }
            }
        }
        """
    "add_link": (label, href)->
        return """
        mutation{
            create_link(label: "#{label}", href: "#{href}"){
                link {
                    uid
                    label
                    href
                    slug
                }
            }
        }
        """
    "run": (mutation_key, args)->
        q = this[mutation_key].apply(null, args)
        return Vue.http.post(settings.graphqlApiUrl, {"query": q})
}
